module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/new/assessment_achievements/4@2x_5070e2d8dd7bb72bae59ea6ea547ae16.png";